import { render, staticRenderFns } from "./RepairRecord.vue?vue&type=template&id=68d06c4c&scoped=true"
import script from "./RepairRecord.vue?vue&type=script&lang=js"
export * from "./RepairRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d06c4c",
  null
  
)

export default component.exports